// const { Map } = require('immutable');
// const newState = Map(state)
// const map2 = newState.set('b', 50)

// import testData from '../../../../airport-resources/google-qpx-LOS-CHI-response-ROUNDTRIP.json'
// import testData from '../../../../airport-resources/google-qpx-LOS-CHI-response.json';
// import all_airlines from '../../../../airport-resources/airlines.json';

let initialState = {
  // user_entered_location_to: null,
  // user_entered_location_from: null,
  // preferredCabin: 'COACH', // Economy
  preferredCabin: 'economy',
  passengers: {
    'adultCount': 1,
    'childCount': 0,
    'infantInLapCount': 0,
    'infantInSeatCount': 0,
    'seniorCount': 0
  }
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'SET_LANDING_PAGE_FORM_VALUES': {
      // console.log('Somto debug called SET_LANDING_PAGE_FORM_VALUES')
      return {...state, ...action.payload }
    }
    case 'SET_FROM_VALUE': {
      return {...state, user_entered_location_from: action.payload}
    }
    case 'SET_TO_VALUE': {
      return {...state, user_entered_location_to: action.payload}
    }
    case 'SET_SELECTED_CABIN': {
      return {...state, preferredCabin: action.payload}
    }
    case 'SET_ADULT_COUNT': {
      return {...state, passengers: changePassengerCount('adultCount', action.payload, state) }
    }
    case 'SET_SENIOR_COUNT': {
      return {...state, passengers: changePassengerCount('seniorCount', action.payload, state) }
    }
    case 'SET_CHILD_COUNT': {
      return {...state, passengers: changePassengerCount('childCount', action.payload, state) }
    }
    case 'SET_INFANT_IN_LAP_COUNT': {
      return {...state, passengers: changePassengerCount('infantInLapCount', action.payload, state) }
    }
    case 'SET_INFANT_IN_SEAT_COUNT': {
      return {...state, passengers: changePassengerCount('infantInSeatCount', action.payload, state) }
    }
    default:
      return state
  }
}

function changePassengerCount (type, count, state) {
  var newAmount = count
  var newPassengers = {...state.passengers}
  newPassengers[type] = newAmount

  return newPassengers
}
// function createCarrierHash (qpxCarrierData) {
//   var hash = {}
//   qpxCarrierData.forEach((carrier) => {
//     hash[carrier.code] = carrier.name
//   })
//
//   return hash
// }



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/reducer.js